import React, { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import useOnboardMobileDeviceApi from "../../hooks/useOnboardMobileDeviceApi";

import fundtapLogo from "../../assets/images/logonew.png";
import applyIdLogo from "../../assets/images/applyid-logo.png";

import "./redirectpage.scss";
import { adduserModal, callBackComp } from "../../locales/en";
import { VERIFY_YOUR_IDENTITY } from "../../route/paths";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";

const MobileDeviceCallBack = () => {
  const { continueOnMobile } = useOnboardMobileDeviceApi();
  const navigate = useNavigate();
  const handleCompleteOnMobile = useCallback(async () => {
    try {
      const response = await continueOnMobile();
      const redirectUrl = response?.data?.data?.start_process_url;
      if (redirectUrl != null) {
        window.location.href = redirectUrl;
      } else {
        navigate(VERIFY_YOUR_IDENTITY);
      }
    } catch {
      showToast(adduserModal.authorizationError, showToastType.error);
    }
  }, [continueOnMobile, navigate]);

  useEffect(() => {
    handleCompleteOnMobile();
  }, [handleCompleteOnMobile]);

  return (
    <div className="redirecting-page-container">
      <div className="redirect-wrap">
        <div className="fundtap-logo">
          <img src={fundtapLogo} alt="fundtap logo" />
        </div>
        <div className="arrow-animation">
          <div className="arrow-right" />
        </div>
        <div className="applyid">
          <img src={applyIdLogo} alt="applyIdLogo" />
        </div>
      </div>
      <div className="redirect-content">
        <p>
          {callBackComp.text1}
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </p>
      </div>
    </div>
  );
};

export default MobileDeviceCallBack;
